import React from 'react';

export interface ApiResultBlockProps {
  loading: boolean;
  result: string | null;
  error: string | null;
  /** Optional label above the result (e.g. "Sonuç") */
  label?: string;
  className?: string;
}

/**
 * Displays loading spinner, API result text, or error for FPS/compatibility calls.
 * Used in listing detail performance cards.
 */
export const ApiResultBlock: React.FC<ApiResultBlockProps> = ({
  loading,
  result,
  error,
  label,
  className = '',
}) => {
  if (loading) {
    return (
      <div className={`mt-3 ${className}`}>
        <div className="d-flex align-items-center text-muted">
          <div className="spinner-border spinner-border-sm text-primary me-2" role="status" aria-hidden="true" />
          <span>Analiz yapılıyor...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className={`mt-3 ${className}`}>
        <div className="alert alert-warning py-2 mb-0 small">
          <i className="fas fa-exclamation-triangle me-2" aria-hidden="true" />
          {error}
        </div>
      </div>
    );
  }

  if (result != null && result !== '') {
    return (
      <div className={`mt-3 ${className}`}>
        {label && (
          <h6 className="text-muted small mb-2">{label}</h6>
        )}
        <div
          className="p-2 rounded sb-surface-muted border small"
          style={{ whiteSpace: 'pre-wrap', maxHeight: '280px', overflowY: 'auto' }}
        >
          {result}
        </div>
      </div>
    );
  }

  return null;
};
